var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.change && (_vm.change || {}).type === "text",
            expression: "change && (change||{}).type === 'text'"
          }
        ],
        staticClass: "custom-tip"
      },
      [_vm._v("修改前: " + _vm._s((_vm.change || {}).tip))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.change && (_vm.change || {}).type === "image",
            expression: "change && (change||{}).type === 'image'"
          }
        ],
        staticClass: "custom-tip"
      },
      [
        _vm._v("\n    修改前: "),
        _c("el-image", {
          staticStyle: { width: "32px", height: "32px" },
          attrs: {
            src: (_vm.change || {}).src,
            "preview-src-list": (_vm.change || {}).preview_src_list
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.change && (_vm.change || {}).type === "video",
            expression: "change && (change||{}).type === 'video'"
          }
        ],
        staticClass: "custom-tip"
      },
      [
        _vm._v("\n    修改前: "),
        _c(
          "video",
          {
            attrs: {
              src: (_vm.change || {}).src,
              width: "32px",
              height: "32px",
              muted: "",
              autoplay: "",
              loop: ""
            },
            domProps: { muted: true }
          },
          [_vm._v("您的浏览器不支持 video 标签")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5068b940", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5068b940","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/idea/ChangeTips.vue
// module id = Me+g
// module chunks = 1